// extracted by mini-css-extract-plugin
export default {"new-fields-modal__list":"NewFieldsModal_new-fields-modal__list__-1h0P"};